import axiosInstance from '../utils/axios';

export interface ApproverUser {
  id: number;
  name: string;
  phone: string;
  username: string;
  role: string;
  role_text: string;
  project_count: number;
}

export interface ApproverProjectOption {
  id: number;
  name: string;
  manager: string;
  status: string;
  approval_mode: string;
  assigned: boolean;
  approver_type: string;
  // 项目配置了按角色审批且命中该审批员的角色，此时无需单独勾选也可审批
  by_role: boolean;
}

export interface ApproverProjectsResponse {
  user: {
    id: number;
    name: string;
    role: string;
    role_text: string;
  };
  assigned_project_ids: number[];
  projects: ApproverProjectOption[];
}

// 获取可作为审批员的用户列表
export const getApprovers = async () => {
  const response = await axiosInstance.get('/users/approvers');
  return response.data;
};

// 获取某审批员负责审批的项目
export const getApproverProjects = async (userId: number) => {
  const response = await axiosInstance.get(`/users/${userId}/approval-projects`);
  return response.data;
};

// 批量设置某审批员负责审批的项目
export const updateApproverProjects = async (userId: number, projectIds: number[]) => {
  const response = await axiosInstance.put(`/users/${userId}/approval-projects`, {
    project_ids: projectIds
  });
  return response.data;
};
